import {Pipe, PipeTransform} from '@angular/core';
@Pipe({name: 'filterList'})
export class FilterListPipe implements PipeTransform {
  transform(value: string, list: any): any[] {
    if (list && value) {
      return list.find((x: any) => x.id === value).text;
    }
  }
}
